module.exports = __webpack_public_path__ + "static/img/smfw_tzjsmfw_scdy.31726d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/smfw_tzjsmfw_scdy.png
// module id = Dj9l
// module chunks = 21